import { cn } from '@/lib/utils';
import { TypeCardTimeTurn } from './types/AdmissionType';

function formatPersianDate(date: string) {
    const monthNames = [
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ];

    const parts = date.split('-');
    if (parts.length !== 3) return 'تاریخ نامعتبر';

    const day = parts[2];
    const monthIndex = parseInt(parts[1], 10) - 1;

    if (monthIndex < 0 || monthIndex > 11) return 'ماه نامعتبر';

    const monthName = monthNames[monthIndex];

    return `${day.slice(0, 1) == '0' ? day.slice(1) : day} ${monthName}`;
}

export default function CardTimeTurn({
    data,
    value,
    currentValue,
    funHnaleder,
    loading,
}: TypeCardTimeTurn) {
    return (
        <div
            onClick={!loading ? () => funHnaleder(value) : undefined}
            className={cn(
                ' rounded-2xl flex_col gap-1 py-2.5  px-3 max-w-[84px] min-w-[84px] w-full text-center shadow-[#E9F9FC]',
                (value === currentValue ||
                    (value === 0 && currentValue === null)) &&
                    ' !bg-blue !border-blue !text-white border shadow-sm',
                !loading
                    ? 'cursor-pointer hover:border-[#15798E] border transition-colors border-blue-shaded bg-blue-shaded hover:shadow-sm w-full'
                    : 'opacity-30 cursor-wait w-full',
            )}
        >
            <p className="!text-sm font-medium whitespace-nowrap">
                {data.date_name}
            </p>
            <p className="!text-xs font-medium whitespace-nowrap pt-0.5">
                {formatPersianDate(data.date_j)}
            </p>
            <p
                className={`${
                    (value === currentValue ||
                        (value === 0 && currentValue === null)) &&
                    'text-blue'
                } text-sm font-bold bg-lavender p-0.5 rounded-md mt-1 whitespace-nowrap`}
            >
                {data.count} نوبت
            </p>
        </div>
    );
}
